import { render, staticRenderFns } from "./IconAttestation.vue?vue&type=template&id=a6dcfb86&scoped=true&"
import script from "./IconAttestation.vue?vue&type=script&lang=js&"
export * from "./IconAttestation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6dcfb86",
  null
  
)

export default component.exports